export interface OwnerSetting {
  id?: string
  ownerId?: string
  smsProvider?: string
  providerToken?: string
  enabled?: boolean
  timeUnit?: string
  frequencyAmount?: number
  daysRemainingToStart?: number
  sendTime?: string
  smsLanguage?: string
  timezone?: string
  defaultSettings?: boolean
  parkingPricePerHour?: number
  createdBy?: string
  updatedBy?: string
  deletedBy?: string
  createdAt?: Date
  updatedAt?: Date
  deletedAt?: Date
}


export enum SMSLanguage {
  English = 'English',
  Amharic = 'Amharic'
}
export enum SMSProvider {
  Geez = 'Geez',
  Afro = 'Afro',
  Hahu = 'Hahu'
}